import React, { useState } from 'react';

import BillsTable from '../../components/vendor-login/ordersComponent/bill/billsTable'

function Bill(props) {
    const [searchValue, setSearchValue] = useState('')

    const handleSearch = (e, data) => {
        setSearchValue(data.value)
    }

    return (
        <React.Fragment>
            <div className="ag=theme-material agOver">
                <BillsTable handleSearch={handleSearch} searchValue={searchValue} {...props} />
            </div>
        </React.Fragment>
    )
}


export default Bill